async function readFile(file: FileList | never[]) {
  const result = await new Promise((resolve) => {
    let fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result);
    fileReader.readAsBinaryString(file[0]);
  });

  return result;
}

export { readFile };
